module.exports = __webpack_public_path__ + "img/Career-Image@2x.5a1ee6d4.png";